import { render, staticRenderFns } from "./record.vue?vue&type=template&id=0b24ae2f&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=0b24ae2f&prod&lang=scss&scoped=true"
import style1 from "./record.vue?vue&type=style&index=1&id=0b24ae2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24ae2f",
  null
  
)

export default component.exports